import React from 'react';
import { Check } from 'lucide-react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
export function Pricing() {
  const plans = [{
    name: 'Foundation',
    price: '1,200',
    description: 'Essential visibility for emerging platforms.',
    bestFor: 'New platforms',
    features: ['Comprehensive SEO audit', 'Keyword & intent research', '4 optimized pages/month', 'Basic technical fixes', 'Monthly performance reporting'],
    highlighted: false,
    color: 'bg-white border-cream-200'
  }, {
    name: 'Growth',
    price: '2,800',
    description: 'Accelerated acquisition for scaling catalogs.',
    bestFor: 'Scaling platforms',
    features: ['Everything in Foundation', 'Full content strategy', '12 optimized articles/month', 'Authority link building', 'Quarterly strategy workshops'],
    highlighted: true,
    color: 'bg-slate-900 text-white border-slate-900',
    badge: 'Most Popular'
  }, {
    name: 'Enterprise',
    price: '5,400',
    description: 'Dominant market share for established leaders.',
    bestFor: 'Established platforms',
    features: ['Everything in Growth', 'Dedicated lead strategist', 'Unlimited content optimization', 'Custom analytics dashboards', 'Priority technical support'],
    highlighted: false,
    color: 'bg-white border-cream-200'
  }];
  return <section id="pricing" className="py-24 md:py-32 bg-cream-50" data-id="element-100">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-101">
        <FadeIn className="text-center max-w-3xl mx-auto mb-20" data-id="element-102">
          <h2 className="text-sm font-bold tracking-widest text-sage-800 uppercase mb-4" data-id="element-103">
            Investment
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-slate-900 leading-tight mb-6" data-id="element-104">
            Transparent Pricing for Growth
          </h3>
          <p className="text-lg text-slate-600" data-id="element-105">
            Partnerships designed to scale with your enrollment goals. No hidden
            fees, just clear deliverables and measurable ROI.
          </p>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-106">
          {plans.map((plan, idx) => <StaggerItem key={idx} data-id="element-107">
              <div className={`relative h-full p-8 md:p-10 rounded-3xl border flex flex-col ${plan.color} ${plan.highlighted ? 'shadow-xl shadow-slate-900/10 scale-105 md:-mt-4 md:mb-4 z-10' : 'shadow-sm'}`} data-id="element-108">
                {plan.badge && <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-sage-200 text-sage-900 text-xs font-bold uppercase tracking-wider py-1.5 px-4 rounded-full" data-id="element-109">
                    {plan.badge}
                  </div>}

                <div className="mb-8" data-id="element-110">
                  <h4 className={`text-2xl font-serif font-medium mb-2 ${plan.highlighted ? 'text-white' : 'text-slate-900'}`} data-id="element-111">
                    {plan.name}
                  </h4>
                  <p className={`text-sm mb-6 ${plan.highlighted ? 'text-slate-300' : 'text-slate-500'}`} data-id="element-112">
                    {plan.description}
                  </p>
                  <div className="flex items-baseline gap-1" data-id="element-113">
                    <span className={`text-3xl font-medium ${plan.highlighted ? 'text-white' : 'text-slate-900'}`} data-id="element-114">
                      €
                    </span>
                    <span className={`text-5xl font-serif font-medium ${plan.highlighted ? 'text-white' : 'text-slate-900'}`} data-id="element-115">
                      {plan.price}
                    </span>
                    <span className={`text-sm ${plan.highlighted ? 'text-slate-400' : 'text-slate-500'}`} data-id="element-116">
                      /mo
                    </span>
                  </div>
                </div>

                <div className={`text-sm font-medium mb-6 py-2 px-4 rounded-lg inline-block self-start ${plan.highlighted ? 'bg-slate-800 text-slate-200' : 'bg-cream-100 text-slate-700'}`} data-id="element-117">
                  Best for: {plan.bestFor}
                </div>

                <ul className="space-y-4 mb-10 flex-grow" data-id="element-118">
                  {plan.features.map((feature, fIdx) => <li key={fIdx} className="flex items-start gap-3" data-id="element-119">
                      <Check size={20} className={`flex-shrink-0 mt-0.5 ${plan.highlighted ? 'text-sage-300' : 'text-sage-800'}`} data-id="element-120" />
                      <span className={plan.highlighted ? 'text-slate-200' : 'text-slate-700'} data-id="element-121">
                        {feature}
                      </span>
                    </li>)}
                </ul>

                <a href="#contact" onClick={e => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className={`w-full py-4 rounded-xl font-medium text-center transition-colors ${plan.highlighted ? 'bg-white text-slate-900 hover:bg-cream-50' : 'bg-slate-100 text-slate-900 hover:bg-slate-200'}`} data-id="element-122">
                  Get Started
                </a>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}